import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";
import { ResetFiltersButton } from "../ResetFiltersButton/ResetFiltersButton";

export type ActiveFilterBarProps = BoxProps & {
  children: ReactNode;
  onResetClick: () => void;
};

export function ActiveFilterBar({
  children,
  sx,
  onResetClick,
  ...boxProps
}: ActiveFilterBarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      {...boxProps}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1,
        }}
        data-testid="active-filter-items"
      >
        {children}
      </Box>
      <ResetFiltersButton onClick={onResetClick} />
    </Box>
  );
}
